import { URLBeacon } from '../URLBeacon';

export const dispatchFoursquareImpression = (creativeKey: string, sourceId: string) => {
  const creative = creativeKey.replace(`${sourceId}-`, '');
  const timestamp = Date.now();
  const url = `https://p.placed.com/api/v2/sync/impression?partner=matterkind&version=1.0&plaid=0063o000019k9xfAAA&payload_campaign_identifier=${creative}&payload_timestamp=${timestamp}&payload_type=impression&xr=tapad`;
  return new URLBeacon({ url });
};
